<template>

   <div ref="modal" class="popupVariant"> 
    
    <div >
      <div
        v-if="tree && tree.length > 1"
        class="sidebar"
      >
        <tree
          ref="tree"
          :tree="tree"
          :left-arrow-last="true"
          :hide-branch="hideObsolete ? 'obsoleto' : null"
          :selected-node="rootEl"
          label="des"
          childs="nodes"
          @select="selectTreeItem"
        ></tree>
      </div>
    </div>
    <div >
      <div class="content col" style="height: 100%; padding-right:0px !important">
        
        <div
          v-if="showImg && filteredElements.length > 0"
          class="d-flex flex-row flex-wrap freeHeight"
          style="overflow-y:auto; max-height: 200px"
        >          
          <div
            v-for="elem in filteredElements"
            :key="elem.cod"
            
            :class="{ 'var-obsolete': elem.enabletype === 2, 'var-deprecated': elem.enabletype === 1 }"
            :title="elem.des"
            style="width: 140px; margin-left:0.1rem !important"
            @click="selectVariant(elem)"
          >
            <div class="imgContainer" >
              <label-img
              :img="elem.img"
              :color="elem.imgColor"
              height="65px"
              width="65px"
              :active="currentVariant === elem.cod"
              />
              <div class="text-center mt-2 label">
                <span
                  class="text-truncate"
                  :class="{ 'text-primary': currentVariant === elem.cod }"
                  v-text="elem.des || '-'"
                ></span>
                <br>
                <span
                  class="text-info text-truncate"
                  v-text="elem.cod"
                ></span>
              </div>
            </div>
            
          </div>
        </div>

        <!--LIST-->
        <div v-else-if="!showImg && filteredElements.length > 0" style="height: 205px; overflow: auto; width: 100%; margin-top: 10px;">          
          <table class="table table-borderless" style="width: 100%">
            <thead>
              <tr>
                <th
                  width="10%"
                  class="border-0"
                  v-html="_trans('Code')"
                ></th>
                <th
                  class="border-0"
                  v-html="_trans('Description')"
                ></th>
                <th
                  v-if="hasImg"
                  class="border-0"
                  v-html="_trans('Img')"
                ></th>
              </tr>
            </thead>
            <tbody >
              <tr
                v-for="elem in filteredElements"
                :title="elem.des"
                style="cursor: pointer; height: 30px;"
                @click="selectVariant(elem)"
              >
                <td
                  :class="{ 'active-bg border-primary' : currentVariant === elem.cod, 'text-muted obsolete' : elem.enabletype === 2 }"
                  v-text="elem.cod"
                >
                </td>
                <td
                  :class="{ 'active-bg': currentVariant === elem.cod, 'text-muted obsolete' : elem.enabletype === 2 }"
                  class="w-100"
                  v-text="elem.des"
                >
                </td>
                <td
                  v-if="hasImg"
                  class="p-0"
                  :class="{ 'active-bg': currentVariant === elem.cod, 'text-muted obsolete' : elem.enabletype === 2 }"
                >
                  <label-img
                    :img="elem.img"
                    :color="elem.imgColor"
                    height="30px"
                    width="30px"
                    class="pr-2"
                    :active="currentVariant === elem.cod"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!--EMPTY CONTENT-->
        <div v-else>
          <h3
            class="text-primary text-center p-3 m-0"
            v-html="_trans('No options')"
          ></h3>
        </div>
      </div>
    </div>
   </div> 
</template>

<script>
  import { customImport  } from "@/utils";
  import {CrulesAPI} from "@3cad/nextcore"
  import { bus } from "@store/dau";

let findParentOfNodeInTree = (node, tree) => {
    let parentNode = null;

    for(let i=0; i<tree.length; i++) {
        let tNode = tree[i];
        if(tNode.cod === node.root)
            parentNode = tNode;
        else if(tNode.nodes && tNode.nodes.length > 0)
            parentNode = findParentOfNodeInTree(node, tNode.nodes);

        if(parentNode !== null)
            break
    }

    return parentNode;
}

let treeSearch = (filter, tree) => {
    if(!filter)
        return tree;

    // Check filter special char
    filter = filter.replace(/\\/g, '\\\\');
    filter = filter.replace(/\+/g, '\\\+');
    filter = filter.replace(/\*/g, '\\\*');
    filter = filter.replace(/\./g, '\\\.');
    filter = filter.replace(/\?/g, '\\\?');
    filter = filter.replace(/\^/g, '\\\^');
    filter = filter.replace(/\$/g, '\\\$');

    let newTree = [];

    let filterRx = new RegExp(filter, "gi");
    for(let i=0; i<tree.length; i++) {
        if(tree[i].des && tree[i].des.match(filterRx))
            newTree.push(tree[i]);
        else {
            let subTree = null;
            if(tree[i].nodes && tree[i].nodes.length > 0) {
                subTree = treeSearch(filter, tree[i].nodes);
            }

            if(subTree && subTree.length > 0) {
                tree[i].nodes = subTree;
                newTree.push(tree[i]);
            }
        }
    }
    return newTree;
};

let treeByFilterLeafs = (tree, leafCodes) => {
    let newTree = [];

    for(let i=0; i<tree.length; i++) {
        // Option 999 - ciclo contrario perchè l'opzione 999 è sempre all'ultimo posto
        if(!tree[i].cod) {
            let exceptionCode = null;
            for(let j=leafCodes.length-1; j>=0; j--) {
                if(leafCodes[j] === null) {
                    newTree.push(tree[i]);
                    break;
                }
            }
        }
        else if(tree[i].cod && leafCodes.indexOf(tree[i].cod) > -1)
            newTree.push(tree[i]);
        else {
            let subTree = null;
            if (tree[i].nodes && tree[i].nodes.length > 0) {
                subTree = treeByFilterLeafs(tree[i].nodes, leafCodes);
            }

            if (subTree && subTree.length > 0) {
                let cpNode = JSON.parse(JSON.stringify(tree[i]));
                cpNode.nodes = subTree;
                newTree.push(cpNode);
            }
        }
    }

    return newTree;
}

export default {
    //mixins: [modal],
    components: {
        labelImg: () => customImport("comp/labelImg.vue"),
        tree: () => customImport("comp/tree.vue"),
    },
    data() {
        return {
            response: {},
            data: {},
            response: {type: Object},
            data: {type: Object, default: {}},
            content: {},
            rootEl: {},
            /** Toggle list of images view
             * true = images
             * false = list
             */
            toggledListImg: false,
            filterElement: '',
            hideObsolete: true
        }
    },
    computed: {
        hasImg() {
            return this.content.hasimg;
        },
        showImg() {
            return this.hasImg && this.toggledListImg;
        },
        currentVariant() {
            return this.data.params.value;
        },
        tree() {
            return this.content.tree;
        },
        filteredElementBySearchObs() {
            if (!this.content || !this.content.d)
                return [];

            let filter = this.filterElement;
            let filterRx = null;
            if(filter) {
                // Check filter special char
                filter = filter.replace(/\\/g, '\\\\');
                filter = filter.replace(/\+/g, '\\\+');
                filter = filter.replace(/\*/g, '\\\*');
                filter = filter.replace(/\./g, '\\\.');
                filter = filter.replace(/\?/g, '\\\?');
                filter = filter.replace(/\^/g, '\\\^');
                filter = filter.replace(/\$/g, '\\\$');
                filterRx = new RegExp(filter, "gi");
            }

            var pippo =  this.content.d.filter(el => {
                let valid = false;
                if(!filterRx)
                    valid = true;
                else
                    valid = el.des.match(filterRx) || el.cod.match(filterRx);

                // Filter obsolete
                if(valid && this.hideObsolete)
                    valid = el.enabletype === 0;

                return valid;
            })
            //bus.$emit('stopLoading');
            return pippo;
            
        },
        filteredElements() {
            return this.filteredElementBySearchObs.filter(el => {
                if (!this.rootEl.cod && this.rootEl.des === '*')
                    return el.cod.match(/^9+$/g) && el.root === null;
                else if(!this.rootEl.cod)
                    return true;
                else
                    return el.root === this.rootEl.cod;
            })
        },
        /*filteredElements() {
            if (!this.content || !this.content.d)
                return false;

            return this.content.d.filter(elem => {
                if (!this.rootEl.cod && this.rootEl.des === '*') {
                    return elem.cod.match(/^9+$/g) && elem.root === null;
                } else if (!this.rootEl.cod) {
                    if (this.hideObsolete) {
                        return (elem.enabletype === 0) && (elem.des.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1 || elem.cod.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1);
                    } else {
                        return (elem.enabletype === 0 || elem.enabletype === 2) && (elem.des.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1 || elem.cod.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1);
                    }
                } else if (elem.root !== this.rootEl.cod) {
                    return false;
                }
                if (this.hideObsolete) {
                    return (elem.enabletype === 0) && (elem.des.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1 || elem.cod.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1);
                } else {
                    return (elem.enabletype === 0 || elem.enabletype === 2) && (elem.des.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1 || elem.cod.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1);
                }
            })
        },*/
        filteredTree() {
            let leafCodes = [];
            for(let i=0; i<this.filteredElementBySearchObs.length; i++) {
                if(leafCodes.indexOf(this.filteredElementBySearchObs[i].root) < 0)
                    leafCodes.push(this.filteredElementBySearchObs[i].root);
            }

            return treeByFilterLeafs(this.tree, leafCodes);
        }
    },
    created() {
      bus.$on('closePopupVariant', () => {
        this.close(-1);
      })      
    },
    beforeDestroy() {
       bus.$off('closePopupVariant')
    },
    methods: {
        hide(e) {
            if(e && ['esc', 'backdrop', 'headerclose'].indexOf(e.trigger) > -1) {
                let mode = -1;
                this.$emit("close", mode, this.response);
            }
        },
        close(mode = -1) {
            this.$emit("close", mode, this.response);
            this.reset();
            bus.$emit('closePopup');
            bus.$emit("closeVariant");
        },
        reset() {
            this.filterElement = '';
            this.rootEl = {};

            if(this.$refs.tree)
                this.$refs.tree.closeTree();

            this.content = {};
        },
        onClose() {
          this.reset();
        },
        onShow() {
            
            CrulesAPI.rulePopVariant(this.data.catalog, this.data.params.cod, this.data.extra, (json) => {
                this.content = json;
                if(this.hasImg)
                    this.toggledListImg = this.hasImg;

                if(this.content.d) {
                    this.content.d.forEach(element => {
                        if(!element.enabletype) element.enabletype = 0; //zero check from the backend
                    });
                }
                this.content.tree = this.content.tree.filter(function(obj){return obj.des != "*"});
                var rispAsterisco = this.content.d.filter(function(obj){return obj.root === null});
                this.content.tree.forEach(ramo=>{
                  rispAsterisco.forEach(foglia=>{
                    foglia.root = ramo.cod
                    //this.content.d.push(foglia);
                  })                  
                })                                
                // Set current variant as visible
                let curValue = this.data.params.value;
                let variants = this.content.d;
                for (let i = 0; i < variants.length; i++) {
                    if (variants[i].cod === curValue) {
                        let tree = this.content.tree;
                        let parentNode = findParentOfNodeInTree(variants[i], tree);
                        if(!parentNode)
                            parentNode = tree[0]
                        this.selectTreeItem(parentNode);
                        break;
                    }
                }
            });
        },
        /** Overwrite method
         * @param variant
         */
        selectVariant(variant) {
            console.log(this.data);
            this.response.cod = this.data.params.cod;
            this.response.value = variant.cod;
            this.close(1);
        },
        /*selectTreeItem(item) {
            this.rootEl = item;
        },*/
        selectTreeItem(data) {
            console.log(data);
            if (data && data.nodes === null) {                             
                this.content.d.filter(function(obj){return obj.root === null}).forEach(foglia=>{
                    foglia.root = data.cod              
                })            
                this.rootEl = data;
                  
            }
        },
        toggleListImg() {
            this.toggledListImg = !this.toggledListImg;
        },
        open(data = {title: "Title", body: "<p>Message</p>"}) {
           
            this.data = data;
            this.onShow();
            // Return object to handle event in one line
            return this;
        }
    }
}
</script>

<style scoped lang="scss">


  .popupVariant {
    // position: relative;
    // top: -69px;
    // left: 0px;
    // right: 0px;
    background-color: #4a4a4a;
    // height: 100%;
    width: 100%;
    .table th, .table td {
          padding: 0 0 0 0.75rem !important;
          vertical-align: middle;
          font-size: 12px;
        }
  }
  .modal-content {
    max-height: 100%;

    .modal-header {
      /*display: block;*/
      .input-group-text{
        background-color: $gray-200;
        color: $secondary;
        &:before{
          color: $secondary;
        }
      }
      .btn-outline-info{
        background-color: $secondary;
      }
      .text-info{
        color: $primary;
      }
      .close{
        padding: 0;
      }
    }

    .modal-body {
      max-height: 100%;
      min-height: 100%;
      overflow: auto;
      background: $primary;

      .sidebar {

      }

      .content {
        min-height: 100%;
        overflow-y: auto;

        .obsolete {
          text-decoration: line-through;
        }
        .table th, .table td {
          padding: 0 0.75rem;
          vertical-align: middle;
        }
      }
    }
  }
  .border-primary{
    border-left: 3px solid $primary;
    background-color: #f2f2f2;
  }
  td.w-100.active-bg {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#f2f2f2+0,ffffff+100 */
    background: #f2f2f2; /* Old browsers */
    background: -moz-linear-gradient(left,  #f2f2f2 0%, #ffffff 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left,  #f2f2f2 0%,#ffffff 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right,  #f2f2f2 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f2f2f2', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */


  }
  .imgContainer{
    display: flex;
    min-height: 100px;
    max-height: 100px;
    height: 100px;    
    line-height: 16px;
    font-size: 12px;
      .card{
        min-width: 65px;
        height: 65px;
        align-self: center;
      }
      .text-center{
        width: 100%;
        overflow: hidden;
        align-self: center;
        text-align: left !important;
        margin-left: 5px;
        margin-right: 5px;
      }
  }


.text-center .mt-2 label{
  overflow: hidden;
  padding-left: 30px;
}
 
.text-truncate{
  line-break: auto;
  white-space: unset;
  width: 100%;
}

.freeHeight{
  .freeHeight{
    max-height: unset !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/dialogs/ogModalVariant.vue